import { Button, Stack, Typography } from '@mui/material';
import Sum from 'components/Sum';
import { ReactNode } from 'react';
import { BRIGHT_BLUE, CLOUD_MIST, DIM_GRAY } from 'utils/theme';

interface AccordionItemProps {
  title: string;
  itemColor: string;
  count: number;
  endIcon: ReactNode;
  onClick: () => void;
  titleColor: string;
  selected: boolean;
}

const AccordionItem = ({
  title,
  itemColor,
  count,
  onClick,
  endIcon,
  titleColor,
  selected,
}: AccordionItemProps) => {
  return (
    <Button
      onClick={onClick}
      endIcon={endIcon}
      sx={{
        borderBottom: selected ? `2px solid ${BRIGHT_BLUE}` : undefined,
        borderRadius: '0px',
        paddingX: '15px',
        paddingTop: { desktop: '8px', tablet: '16px', mobile: '16px' },
        paddingBottom: {
          desktop: selected ? '5px' : '8px',
          tablet: selected ? '12px' : '16px',
          mobile: selected ? '12px' : '16px',
        },
        backgroundColor: { CLOUD_MIST },
        '&:hover': {
          backgroundColor: { DIM_GRAY },
        },
      }}
    >
      <Stack direction={'row'} spacing={1} alignItems="center">
        <Sum color={itemColor} count={count} isSum={true} />
        <Typography fontSize="14px" color={titleColor} letterSpacing="0.28px">
          {title}
        </Typography>
      </Stack>
    </Button>
  );
};

export default AccordionItem;
